import { IOfferCard } from '../../../types/card';

export function getFlatTitle(offerCard: IOfferCard) {
  const { isApartments, flatType, roomsCount } = offerCard;
  if (flatType === 'studio') {
    return isApartments ? 'Апартаменты-студия' : 'Студия';
  }

  if (flatType === 'openPlan') {
    return 'Своб. планировка';
  }

  return roomsCount ? `${roomsCount}-комн. ${isApartments ? 'апартаменты' : 'квартира'}` : '';
}
